import type { API } from 'api/config/types';
import { TimeControl } from 'chessboard/api/time-control/config/types';

/**
 * Create the setTimeControl method.
 */
export function createSetTimeControl(context: API.Context) {
  /**
   * Set a new time control. This resets the clocks with the new value.
   */
  return function setTimeControl(timeControl: TimeControl.Model | null) {
    const { api } = context;

    if (timeControl === null) {
      return api.setGameDetails({ TimeControl: TimeControl.Header.Null });
    }

    const { baseTime, increment } = timeControl;

    const baseTimeInSeconds = baseTime / 1000;
    const incrementInSeconds = increment / 1000;

    return api.setGameDetails({
      TimeControl: incrementInSeconds
        ? `${baseTimeInSeconds}+${incrementInSeconds}`
        : `${baseTimeInSeconds}`,
    });
  };
}
